import { OrganizationMember } from '@prisma/client'
import { Flex } from 'antd'
import React, { useState } from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { OrganizationMetricsOverview } from '~/features/organization/client/components/MetricsOverview'
import { OrganizationType } from '~/features/organization/common'
import { LeftbarDrawer } from '~/features/shared/components'
import { ContactBarItem } from '../ContactBarItem'
import { useData } from './hooks/useData'
import { useLogic } from './hooks/useLogic'

type Props = {
  conversationId?: string
  organization: OrganizationType
  organizationMember: OrganizationMember
  organizationMembers?: OrganizationMemberFromContext[]
}

export const ContactBarV2: React.FC<Props> = ({
  conversationId,
  organization,
  organizationMember,
  organizationMembers,
}) => {
  const [isOpen, setOpen] = useState(true)

  const data = useData({
    conversationId,
    organization,
    organizationMember,
    organizationMembers,
  })

  const logic = useLogic({
    organization,
    conversationId,
    organizationMember,
    organizationMembers,
    conversations: data.conversations,
  })

  return (
    <>
      <Flex vertical className="h-full" style={{ minWidth: '48px' }}>
        <LeftbarDrawer
          isOpen={isOpen}
          width="400px"
          background="white"
          offsetToggle="0px"
          onClick={() => setOpen(!isOpen)}
        >
          <Flex className="w-full h-full pr-2" align="space-between" vertical>
            <Flex vertical flex={1}>
              {data.items.map(item => (
                <ContactBarItem
                  key={item.key}
                  isActive={item.key === conversationId}
                  isTyping={!!data.typing?.[item.conversation?.id]}
                  countNotifications={item.countNotifications}
                  organization={organization}
                  organizationMember={item.member}
                  conversation={item.conversation}
                  messageLast={item.messageLast}
                  onSelect={() => logic.selectItem(item.key)}
                />
              ))}
            </Flex>
            <OrganizationMetricsOverview organization={organization} />
          </Flex>
        </LeftbarDrawer>
      </Flex>
    </>
  )
}
